import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Dashboard from './Dashboard';
import type { User } from './analytics';
import './styles.css';

async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', ...init?.headers }, ...init });
  if (!response.ok) throw new Error((await response.json().catch(() => ({}))).error || `HTTP ${response.status}`);
  return response.status === 204 ? (undefined as T) : response.json();
}

function Login({ onLogin }: { onLogin: (user: User) => void }) {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setLoading(true); setError('');
    try { onLogin((await api<{ user: User }>('/api/login', { method: 'POST', body: JSON.stringify({ username, password }) })).user); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Accesso non riuscito'); }
    finally { setLoading(false); }
  };
  return <main className="login-shell">
    <section className="login-story">
      <div className="brand"><span className="brand-mark">M</span><span>MEINARDI <b>DEV</b></span></div>
      <div className="story-copy">
        <span className="eyebrow">ANALYTICS LAB · INTERACTIVE DATA STUDIO</span>
        <h1>Dal dato.<br /><em>Alla decisione.</em></h1>
        <p>Dieci dashboard, oltre quindici modelli visuali e un percorso di esplorazione continuo fino alla tabella di dettaglio.</p>
      </div>
      <div className="story-stats"><div><span>10</span><small>dashboard tematiche</small></div><div><span>17+</span><small>modelli interattivi</small></div><div><span>24 mesi</span><small>di dati coerenti</small></div></div>
    </section>
    <section className="login-panel">
      <form onSubmit={submit}>
        <span className="eyebrow">ACCESSO RISERVATO</span>
        <h2>Bentornato</h2><p>Entra nel laboratorio CFO.</p>
        <label>Profilo demo<select value={username} onChange={(event) => setUsername(event.target.value)}><option value="admin">Admin · tutte le aziende</option><option value="edilfast">Edilfast · dati segregati</option><option value="client_a">Client A · dati segregati</option></select></label>
        <label>Password<input autoFocus type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Password del profilo" /></label>
        {error && <div className="form-error">{error}</div>}
        <button className="primary" disabled={loading}>{loading ? 'Verifica…' : 'Accedi al laboratorio'} <span>→</span></button>
        <small>Credenziali configurate esclusivamente tramite secret di ambiente.</small>
      </form>
    </section>
  </main>;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => { api<{ user: User }>('/api/session').then((response) => setUser(response.user)).catch(() => {}).finally(() => setReady(true)); }, []);
  if (!ready) return <div className="splash"><span className="brand-mark">M</span></div>;
  return user ? <Dashboard user={user} onLogout={() => setUser(null)} /> : <Login onLogin={setUser} />;
}

createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
